// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"3467c52e","54":"aae5812c","669":"45300076"}[chunkId] + ".chunk.js";
};